import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, Tag } from 'antd';
import { ajaxGet } from '../../utils/ajax';
import './updateAlert.less';

const titleColor = ['red', '#F5A623', 'blue'];
const tagClass = ['contailer_alert_hint', 'contailer_alert_warn', 'contailer_alert_inform '];


export default class UpdateAlert extends Component {
    static propTypes = {
        closeCallback: PropTypes.func,// eslint-disable-line
        updateCallback: PropTypes.func,// eslint-disable-line
        type: PropTypes.string, // eslint-disable-line
    }
    constructor(props) {
        super(props);
        this.state = {
            isClose: false,
            isShowAlert: false,
            isNotHunter: props.type !== 'hunter',
            noticeCont: '系统即将于更新，请届时暂停操作！',
            announcementFlag: 0, //公告标识
        };
        this.noticeReq = '';
    }

    componentWillMount() {
        if (this.noticeReq) {
            clearInterval(this.noticeReq);
        }

        // if (window.location.hash && window.location.hash.includes('from=wb')) {
        //   this.load(2)
        // } else {
        //   this.load(1)
        // }
        this.load();
        this.getNotice();
    }

    getNotice = () => {// eslint-disable-line
        this.noticeReq = setInterval(this.load, 1000 * 60 * 15);
    };

    load = (type = 1) => {
        if (this.state.isClose) {
            clearInterval(this.noticeReq);
            return;
        }

        ajaxGet(`/recruit/api/announcement/banner/announcement`, { publishingPlatform: type }, (data) => {
            const notice = data.data || '';

            if (!notice || !notice.title || !notice.content) {
                this.setState({
                    isShowAlert: false,
                });
                this.props.closeCallback && this.props.closeCallback(); // eslint-disable-line
                return;
            }
            this.setState({
                isShowAlert: true,
                noticeCont: this.getNoticeCont(notice.title, notice.content, notice.announcementFlag),
                announcementFlag: notice.announcementFlag,
            });

            this.props.updateCallback && this.props.updateCallback();// eslint-disable-line
        });
    };

    getNoticeCont = (title, content, count) => (
        <span id="js_notice_info_ct">
            <Tag color={titleColor[count - 1]}>{title}</Tag>：{content}
        </span>
    );

    onClose = () => {
        this.setState({
            isShowAlert: false,
            isClose: true,
        }, () => {
            this.props.closeCallback && this.props.closeCallback();// eslint-disable-line
        });
    };

    render() {
        const isShowAlert = this.state.isShowAlert;
        return (
            <div id="js_container_alert_ct">
                {
                    this.state.isNotHunter && isShowAlert ?
                        <Alert closable banner message={this.state.noticeCont} className={`container_alert_ct ${tagClass[this.state.announcementFlag - 1]}`} type="info" onClose={this.onClose} showIcon />
                        : ''
                }
            </div>
        );
    }
}
